export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/500/img-server-error-52362c7af362544ccb65f4d0c8c961b9.svg";